import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import LandingPage from './pages/LandingPage';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Disclaimer from './pages/Disclaimer';
import BlogIndexPage from './pages/BlogIndexPage';
import BlogPostPage from './pages/BlogPostPage';
import GiveawaysPage from './pages/GiveawaysPage';
import JoinPage from './pages/JoinPage';
import BookCallPage from './pages/BookCallPage';
import PersonalCallPage from './pages/PersonalCallPage';
import ClipLandingPage from './pages/clip/ClipLandingPage';
import ClipAuthPage from './pages/clip/ClipAuthPage';
import ClipDashboardPage from './pages/clip/ClipDashboardPage';
import AdminClippersPage from './pages/AdminClippersPage';
import StaffLoginPage from './pages/staff/StaffLoginPage';
import StaffDashboardPage from './pages/staff/StaffDashboardPage';
import { I18nProvider } from './lib/i18n';

function App() {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" richColors />
      <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/blog" element={<BlogIndexPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/giveaways" element={<GiveawaysPage />} />
            <Route path="/giveaways/:slug" element={<GiveawaysPage detail />} />
            <Route path="/join" element={<JoinPage />} />
            <Route path="/book-call" element={<BookCallPage />} />
            <Route path="/personal-call" element={<PersonalCallPage />} />
            <Route path="/clip" element={<ClipLandingPage />} />
            <Route path="/clip/login" element={<ClipAuthPage mode="login" />} />
            <Route path="/clip/signup" element={<ClipAuthPage mode="signup" />} />
            <Route path="/clip/dashboard" element={<ClipDashboardPage />} />
            <Route path="/staff/login" element={<StaffLoginPage />} />
            <Route path="/staff/dashboard" element={<StaffDashboardPage />} />
            <Route path="/admin/nayemur/alvee/login" element={<AdminLogin />} />
            <Route path="/admin/nayemur/alvee" element={<AdminDashboard />} />
            <Route path="/admin/clippers/nayemur" element={<AdminClippersPage />} />
            <Route path="/admin/nayemur/alvee/clippers" element={<AdminClippersPage />} />
            <Route path="/admin/clippers" element={<AdminClippersPage />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="*" element={<LandingPage />} />
          </Routes>
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
